import { useEffect, useState } from 'react';
import { Icon, SemanticCOLORS, Table } from 'semantic-ui-react';
import { MetaDataElement } from '../../../app/models/metaDataConfig';
import { store, useStore } from '../../../app/stores/store';
import agent from '../../../app/api/agent';
import { Link } from 'react-router-dom';

interface AddChildI extends MetaDataElement {
  elementCurrentIndex: string;
  child: AddChildI[];
}

interface MetadataHierarchyPropsI {
  elementDetails: AddChildI;
  onClickHandler: (elementId: string, elementCurrentIndex: string) => void;
  RaiFirstOpen: any;
}

let color = ['teal', 'blue', 'orange', 'olive', 'brown'];

export default function MetadataHierarchy(props: MetadataHierarchyPropsI) {
  const { commonStore, activityStore, userStore } = useStore();

  const { elementDetails, onClickHandler, RaiFirstOpen } = props || {};
  const {
    elementId,
    elementType,
    elementName,
    elementValue,
    elementCurrentIndex,
    hasChild,
    templateElementId,
  } = elementDetails;

  const [isVisible, setIsVisible] = useState(false);
  const [localElementValue, setLocalElementValue] = useState<string>('');
  const[associatedElements, setAssociatedElements]= useState<any[]>([])

  useEffect(() => {
    if (elementType === 'Masters' || elementType === 'Users') {
      setLocalElementValue(elementValue?.split('|')?.[1]);
    } else if (elementType === 'DynamicTable') {
      if (elementValue?.includes('DynamicTable|')) {
        let splitValue;
        const stringData = elementValue?.split('DynamicTable|')?.[1];
        let tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
        const rowsList: string[] = [];
        if (tempValue[0]) {
          let columnHeaders: string[] = Object.keys(tempValue[0]);
          columnHeaders = columnHeaders?.filter((data) => data !== '_uuid_');
          tempValue?.forEach((val: any) => {
            let rowVal = '';
            columnHeaders?.forEach((header: string, index: number) => {
              if (header !== '_uuid_') {
                rowVal += header?.split('_')?.join(' ');
                rowVal += ': ';
                rowVal += val?.[header];
                if (index !== columnHeaders.length - 1) {
                  rowVal += '\n';
                }
              }
            });
            rowsList.push(rowVal);
          });
          splitValue = rowsList.join('\n\n');
          setLocalElementValue(splitValue);
        } else {
          setLocalElementValue('');
        }
      }
    } else if (elementType === 'DropDown') {
      const tempVal = elementValue?.split('|')?.join(',');
      setLocalElementValue(tempVal);
    } else {
      setLocalElementValue(elementValue);
    }
  }, [elementValue, elementType]);

  const positionHandler = (elementCurrentIndex: string) => {
    let paddingLeft = (elementCurrentIndex?.split('_')?.length || 1) * 10;
    return {
      position: 'relative',
      paddingLeft,
    };
  };
  useEffect(() => {
    if (RaiFirstOpen?.elementName === elementName) {
      expand([]);
    }
    // eslint-disable-next-line
  }, []);
  const expand = async(e: any) => {
    if (RaiFirstOpen?.elementName === elementName && e.length !== 0) {
      e.stopPropagation();
    }
    if (hasChild) {
      setIsVisible(!isVisible);
      if (!isVisible || RaiFirstOpen?.elementName === elementName)
        onClickHandler(elementId, elementCurrentIndex);
    }
    if(elementType=== "Parent" && userStore.user?.customerName==="HFC Media Services"){
      setIsVisible(!isVisible);
      const res= await agent.HFC.AssociatedElements(activityStore.selectedActivity?.id)
      setAssociatedElements(res.data)
    }
  };

  return (
    <>
      {!commonStore.filterModeTwo.includes(templateElementId) && (
        <Table.Row
          disabled={commonStore.filterModeZero.includes(templateElementId)}
          className={elementType === 'Parent' ? 'metadataHierarchyParent' : ''}
          style={{
            cursor: 'pointer',
          }}
          onClick={expand}
        >
          {elementType === 'Parent' ? (
            <Table.Cell colspan="100%">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {store.userStore.user?.customerName==="HFC Media Services" || hasChild ? (
                  <Icon
                    name={!isVisible ? 'plus' : 'minus'}
                    color={
                      !isVisible
                        ? 'grey'
                        : (color[
                            (Math.ceil(elementCurrentIndex?.length / 2 - 1) ||
                              0) % 5
                          ] as SemanticCOLORS)
                    }
                    size="small"
                    style={{ opacity: '.7' }}
                  />
                ) : (
                  <span style={{ width: '12.40px' }}></span>
                )}
                <span
                  style={{
                    wordBreak: 'break-word',
                    paddingLeft: 10,
                  }}
                >
                  {elementName}
                </span>
              </div>
            </Table.Cell>
          ) : (
            <>
              <Table.Cell
                style={positionHandler(elementCurrentIndex)}
                width={7}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {hasChild ? (
                    <Icon
                      name={!isVisible ? 'plus' : 'minus'}
                      color={
                        !isVisible
                          ? 'grey'
                          : (color[
                              (Math.ceil(elementCurrentIndex?.length / 2 - 1) ||
                                0) % 5
                            ] as SemanticCOLORS)
                      }
                      size="small"
                      style={{ opacity: '.7' }}
                    />
                  ) : (
                    <span style={{ width: '16px' }}></span>
                  )}
                  <span
                    style={{
                      wordBreak: 'break-word',
                      paddingLeft: 10,
                    }}
                  >
                    {elementName}
                  </span>
                </div>
              </Table.Cell>
              <Table.Cell width={7}>
                {!!elementValue?.length && (
                  <span
                    style={{ wordBreak: 'break-word' }}
                    className="metadataHierarchy"
                  >
                    {localElementValue}
                  </span>
                )}
              </Table.Cell>
            </>
          )}
        </Table.Row>
      )}
      {isVisible && elementDetails?.child ? (
        (elementDetails?.child || [])?.map((data) => {
          return (
            <MetadataHierarchy
              elementDetails={data}
              onClickHandler={onClickHandler}
              RaiFirstOpen={[]}
            />
          );
        })
      ) : (
        <></>
      )}
  {
  isVisible && elementName === "Associated Elements" && elementDetails?.child && (
    associatedElements
      .map((item: any) => {
        const [linkText, linkTo] = item.split('|');
        return { linkText: linkText.trim(), linkTo: linkTo.trim() };
      })
      // Sort the elements by the linkText alphabetically
      .sort((a, b) => a.linkText.localeCompare(b.linkText))
      .map((item: any) => (
        <Table.Row key={item.linkText} style={{ width: '100%' }}>
          <Table.Cell 
            colSpan="100%" 
            style={{ width: '100%', backgroundColor: 'white', paddingLeft: '40px' }}
          >
            <Link 
              to={`/mediaAssets/${item.linkTo}`}  
            >
              {item.linkText}
            </Link>
          </Table.Cell>
        </Table.Row>
      ))
  )
}
    </>
  );
}
